export default "﻿<div class=\"accordion\">\n    <div data-dojo-attach-point=\"entriesContainer\"></div>\n</div>"